import { render } from "./AiChat.vue?vue&type=template&id=f3aa2546&scoped=true"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"

import "./AiChat.vue?vue&type=style&index=0&id=f3aa2546&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3aa2546"]])

export default __exports__